import styled from '@emotion/styled';
import { Button, ButtonWrap } from '../../../ui';
import log from 'loglevel';
import React from 'react';
import { FormProvider, useFormContext } from 'react-hook-form';
import { object, string } from 'yup';
import { AutoSuggestField } from '../../shared/components/auto-suggest/AutoSuggestField';
import { useForm } from '../../shared/form/useForm';

const items = ['apple', 'banana', 'grape', 'grapefruit', 'orange', 'pear'];

interface IAutoSuggestFormData {
	someAutoSuggest: string;
	anotherAutoSuggest: string;
}

const defaultValues: IAutoSuggestFormData = {
	someAutoSuggest: '',
	anotherAutoSuggest: 'orange',
};

export const AutoSuggestForm = () => {
	const form = useForm<IAutoSuggestFormData>({
		defaultValues,
		validationSchema: object({
			someAutoSuggest: string().required(),
			anotherAutoSuggest: string().required(),
		}).required(),
	});

	const onSubmit = (data: IAutoSuggestFormData) => {
		log.info('Submit form', data);
	};

	return (
		<>
			<h2 id="autosuggest-form">Auto Suggest Form Fields</h2>
			<form onSubmit={form.handleSubmit(onSubmit)}>
				<FormProvider {...form}>
					<Row>
						<AutoSuggestField
							name="someAutoSuggest"
							label="Some auto suggest"
							items={items}
						/>
					</Row>
					<Row>
						<AutoSuggestField
							name="anotherAutoSuggest"
							label="Another auto suggest (with default)"
							items={items}
						/>
					</Row>
					<Actions>
						<ResetButton />
						<SubmitButton />
					</Actions>
				</FormProvider>
			</form>
		</>
	);
};

const ResetButton = () => {
	const form = useFormContext<IAutoSuggestFormData>();

	return (
		<Button type="button" onClick={() => form.reset(defaultValues)}>
			Reset
		</Button>
	);
};

const SubmitButton = () => <Button type="submit">Submit</Button>;

const Row = styled.div`
	& ~ & {
		margin-top: 24px;
	}
`;

const Actions = styled(ButtonWrap)`
	margin-top: 24px;
`;
